module.exports = __webpack_public_path__ + "img/identity.dd84199c.svg";